module.exports = __webpack_public_path__ + "media/images/user-avatar-0f11d24780f41e2cc0ad40918a2ecd82b83e214db72e3dc20ca9584353b34842.svg";